module.exports = __webpack_public_path__ + "static/media/pic2@2x.17b9ee87.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/pic2@2x.png
// module id = 1414
// module chunks = 0